import CONSTANTS from "../CONSTANTS";

export const actionSetCategoryMenu = (category) => ({
    type: CONSTANTS.CATEGORY_MENU_UPDATE,
    category
  });